import { render } from "./SelectLimitationProfileDialog.vue?vue&type=template&id=861f435c"
import script from "./SelectLimitationProfileDialog.vue?vue&type=script&lang=js"
export * from "./SelectLimitationProfileDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__